/* ============================================================================
   Aquarylic Global Theme Scripts
   Theme: Broadcast 8.1.1
   Purpose: Keep Aquarylic-specific JavaScript out of theme.js/custom.js.
   ============================================================================ */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Collection cards: preserve anchor jump for collection teaser links
     ------------------------------------------------------------------------ */
  function applyCollectionHeroAnchors() {
    var links = document.querySelectorAll('.collection-item__content[href]');
    links.forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        url.hash = 'shopify-section-template--23193145835853__hero';
        link.href = url.toString();
      } catch (error) {
        // Ignore malformed or non-standard links.
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCollectionHeroAnchors);
  } else {
    applyCollectionHeroAnchors();
  }

  /* ------------------------------------------------------------------------
     Klaviyo forms: persist URL parameters and forward successful Meta leads
     ------------------------------------------------------------------------ */
  (function trackKlaviyoLeadSource() {
    var keys = [
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
      'ad_id', 'adset_id', 'campaign_id', 'placement', 'tw_adid', 'audience', 'fbclid'
    ];

    var qs = new URLSearchParams(window.location.search);

    keys.forEach(function (key) {
      var value = qs.get(key);
      try {
        if (value) window.localStorage.setItem('kw_' + key, value);
      } catch (error) {}
    });

    function getStoredValue(key) {
      try {
        return window.localStorage.getItem('kw_' + key) || '';
      } catch (error) {
        return '';
      }
    }

    function fill(root) {
      if (!root || !root.querySelectorAll) return;

      root.querySelectorAll('input[name="source"]').forEach(function (input) {
        if (!input.value) input.value = 'site_klaviyo';
      });

      keys.forEach(function (key) {
        var value = qs.get(key) || getStoredValue(key) || '';
        if (!value) return;

        root.querySelectorAll('input[name="' + key + '"]').forEach(function (input) {
          if (!input.value) input.value = value;
        });
      });
    }

    function isMetaTraffic() {
      var source = (qs.get('utm_source') || '').toLowerCase();
      if (qs.get('fbclid')) return true;
      if (qs.get('ad_id') || qs.get('adset_id') || qs.get('campaign_id')) return true;
      if (source.indexOf('facebook') > -1 || source.indexOf('instagram') > -1 || source.indexOf('meta') > -1) return true;
      return document.cookie.indexOf('_fbc=') > -1;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { fill(document); });
    } else {
      fill(document);
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          fill(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('klaviyoForms', function (event) {
      if (!event || !event.detail || event.detail.type !== 'success') return;
      if (!isMetaTraffic() || !window.fbq) return;

      var eventId = 'kw-' + Date.now() + '-' + Math.random().toString(36).slice(2);
      window.fbq('track', 'Lead', { content_name: 'Klaviyo Signup', event_id: eventId });
    });
  })();

    /* ------------------------------------------------------------------------
      Cart count sync moved to assets/aq-cart-submit-guard.js

      Wichtig:
      Der alte Block hat window.fetch und XMLHttpRequest global gepatcht und nach
      jedem /cart/add|change|update|clear zusätzlich /cart.js geladen. Zusammen
      mit Qikify Slide Cart, BOGO/Freegift und der Rabattlogik konnte das den
      mobilen Add-to-cart-Flow spürbar verzögern.
      ------------------------------------------------------------------------ */

    /* ------------------------------------------------------------------------
     Anchor links: smooth scroll with sticky header / trustbadge offset
     ------------------------------------------------------------------------ */
  (function anchorScrollWithOffset() {
    var targetSections = {
      '#productgrid': ['__main'],
      '#category': ['__section_rich_text_pfWCEx', '__section_rich_text_pfWCEx_TEST'],
      '#startersetgrid': ['__section_rich_text_JzMMUW'],
      '#produktsetgrid': ['__section_rich_text_UNeqqf'],
      '#kurssetgrid': ['__section_rich_text_PN6QLk']
    };

    function getOffsetTopWithHeader(targetEl) {
      var isMobile = window.innerWidth <= 767;
      var header = document.querySelector(isMobile ? '.header__mobile' : '.header__desktop');
      var trusted = document.querySelector('#trustbadge-topbar-container-98e3dadd90eb493088abdc5597a70810');

      var headerHeight = header && header.offsetHeight > 0 ? header.offsetHeight : (isMobile ? 102 : 168);
      var trustedHeight = trusted && trusted.offsetHeight > 0 ? trusted.offsetHeight : 0;

      var baseOffset = 20;

      if (isMobile) {
        baseOffset -= 50;
      } else {
        baseOffset += 10;
      }

      var offset = -(headerHeight + trustedHeight + baseOffset);
      return targetEl.getBoundingClientRect().top + window.pageYOffset + offset;
    }

    function scrollToAnchorWithOffset(hash) {
      if (!hash || hash === '#') return;

      if (targetSections[hash]) {
        var attempts = 0;
        var maxAttempts = 50;
        var delayed = false;

        function tryScroll() {
          if (hash === '#category' && window.innerWidth <= 767 && attempts === 0 && !delayed) {
            delayed = true;
            window.setTimeout(tryScroll, 200);
            return;
          }

          for (var i = 0; i < targetSections[hash].length; i += 1) {
            var ending = targetSections[hash][i];
            var section = document.querySelector('[id^="shopify-section-template--"][id$="' + ending + '"]');

            if (section) {
              var y = getOffsetTopWithHeader(section);
              window.scrollTo({ top: y, behavior: 'smooth' });
              return;
            }
          }

          if (attempts < maxAttempts) {
            attempts += 1;
            window.setTimeout(tryScroll, 50);
          }
        }

        tryScroll();
        return;
      }

      try {
        var target = document.querySelector(hash);
        if (target) {
          var y = getOffsetTopWithHeader(target);
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      } catch (error) {
        // Ignore invalid selectors.
      }
    }

    function initAnchorScroll() {
      var initialHash = window.location.hash;

      if (initialHash) {
        window.setTimeout(function () {
          scrollToAnchorWithOffset(initialHash);
        }, 200);
      }

      document.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var hash = link.getAttribute('href');

          if (!hash || hash === '#') return;

          var targetExists = Boolean(targetSections[hash]);

          if (!targetExists) {
            try {
              targetExists = Boolean(document.querySelector(hash));
            } catch (error) {
              targetExists = false;
            }
          }

          if (targetExists) {
            event.preventDefault();
            scrollToAnchorWithOffset(hash);
            window.history.pushState(null, '', hash);
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAnchorScroll);
    } else {
      initAnchorScroll();
    }
  })();


  /* ------------------------------------------------------------------------
     Password page: rename "Powered by Shopify" footer link text
     ------------------------------------------------------------------------ */
  (function renamePoweredByShopify() {
    function run() {
      document.querySelectorAll('.copyright__content a').forEach(function (element) {
        if (element.textContent.trim() === 'Powered by Shopify') {
          element.textContent = 'Shopify';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  /* ==========================================================================
   AQ Discount Badge System
   Version: 1.1.0
   Campaign: 5 Jahre Aquarylic / 5JAHREFARBE
   Fixes:
   - Uses pre-discount merchandise subtotal for the 50 € threshold
   - Adds Qikify cart drawer campaign message
   - Re-renders after cart add/change/update/clear requests
   - Keeps product grids intentionally non-variable to avoid confusing messages
   ========================================================================== */

  (function () {
    'use strict';

    /* ==========================================================================
      AQ Campaign Control
      Change this block first for future campaigns.
      Keep campaign-specific inputs here so the sensitive rendering logic below
      stays stable.
      ========================================================================== */

    const AQ_CAMPAIGN_CONTROL = {
      enabled: true,

      code: '5JAHREFARBE',
      landingPath: '/pages/aquarylic-feiert-geburtstag',

      countdown: {
        enabled: true,

        /*
          Fixe Endzeit als UTC-Zeitpunkt.
          Beispiel: Ende am 10.05.2026 um 17:00 Uhr CEST
          = 2026-05-10T15:00:00Z.
        */
        endsAtIso: '2026-05-10T15:15:00Z',

        label: 'Nur noch',
        expiredText: 'Geburtstagsaktion beendet'
      },

      /*
        Trigger-System:
        - paths: aktiviert Badge-System auf bestimmten Seiten.
        - queryParams: aktiviert Badge-System über URL-Parameter.
        - utmRules: aktiviert Badge-System über UTM-Regeln.
        - redirectThroughDiscountLink: optionaler Einmal-Redirect über /discount/CODE,
          damit der Rabatt im Shopify-Checkout wirklich gesetzt ist.
      */
      trigger: {
        enabled: true,

        paths: [
          {
            path: '/pages/aquarylic-feiert-geburtstag',
            match: 'exact'
          }

          /*
            Beispiele für spätere Ergänzungen:

            Exakte PDP:
            {
              path: '/products/aquarylic-color-starterset',
              match: 'exact'
            }

            Ganze Collection inklusive Unterpfade:
            {
              path: '/collections/aquarylic-color',
              match: 'prefix'
            }
          */
        ],

        queryParams: [
          {
            name: 'aq_discount',
            values: ['5JAHREFARBE'],
            match: 'equals'
          },
          {
            name: 'discount',
            values: ['5JAHREFARBE'],
            match: 'equals'
          }
        ],

        utmRules: [
          /*
            Beispiel 1:
            Triggert, wenn utm_medium paid oder PaidSocial ist.
            Reihenfolge der URL-Parameter ist egal.

            {
              operator: 'all',
              conditions: [
                {
                  name: 'utm_medium',
                  values: ['paid', 'PaidSocial'],
                  match: 'equals'
                }
              ]
            }
          */

          /*
            Beispiel 2:
            Triggert nur, wenn utm_medium paid ist UND utm_campaign 5jahre enthält.

            {
              operator: 'all',
              conditions: [
                {
                  name: 'utm_medium',
                  values: ['paid', 'PaidSocial'],
                  match: 'equals'
                },
                {
                  name: 'utm_campaign',
                  values: ['5jahre', 'geburtstag'],
                  match: 'contains'
                }
              ]
            }
          */
          {
            operator: 'all',
            conditions: [
              {                
                name: 'utm_medium',
                values: ['paid', 'paidsocial'],
                match: 'equals'
              }
            ]
          }
        ],

        /*
          false = nur Badge-System / Cart Message / Return-Bar aktivieren.
          true  = einmalig über Shopify /discount/CODE gehen und zurück zur aktuellen Seite.
                  Sinnvoll für Paid Ads direkt auf PDPs, wenn der Rabatt im Checkout
                  sicher gesetzt sein soll.
        */
        redirectThroughDiscountLink: {
          enabled: false,

          /*
            Nur diese Trigger-Quellen lösen den Shopify-/discount/-Redirect aus.

            Sinnvoll:
            - 'utmRules' für Paid-Ad-Traffic direkt auf PDPs / Collections

            Nicht empfohlen:
            - 'paths', weil sonst die Landingpage selbst redirecten würde
            - 'queryParams', weil ?discount=... meistens schon bewusst gesetzt ist
            - 'shopifyDiscountPath', weil das bereits der Discount-Link ist
            - 'stored', weil sonst spätere Besuche unnötig redirecten würden
          */
          sources: ['utmRules'],

          sessionKey: 'aq_campaign_discount_redirect_done'
        },

        /*
          Optionaler Landingpage-Zwang.
          Empfehlung: false lassen, weil der User bei PDP-Ads bewusst auf dieses Produkt wollte.
        */
        redirectToLandingPage: {
          enabled: false,
          url: '/pages/aquarylic-feiert-geburtstag'
        }
      },

      returnBar: {
        enabled: true,
        text: '−20 % auf das gesamte Sortiment sichern',
        ariaLabel: 'Geburtstagsaktion: 20 Prozent auf das gesamte Sortiment sichern',
        url: '/discount/5jahrefarbe?redirect=/pages/aquarylic-feiert-geburtstag',
        hideOnLandingPage: true
      }
    };

    const AQ_DISCOUNT_CONFIG = {
      enabled: true,

      urlParamNames: ['aq_discount', 'discount'],

      storageKey: 'aq_active_discount_code',
      storageExpiresAtKey: 'aq_active_discount_expires_at',

      persistDays: 14,

      campaignLandingPages: {
        [AQ_CAMPAIGN_CONTROL.landingPath]: AQ_CAMPAIGN_CONTROL.code
      },

      offers: {
        [AQ_CAMPAIGN_CONTROL.code]: {
          code: AQ_CAMPAIGN_CONTROL.code,
          type: 'percentage',
          value: 20,
          minSubtotalCents: 5000,
          appliesTo: 'all',
          productHandles: [],
          applyToCart: false,

          badgeGrid: 'zusätzlich −20 % Geburtstagsrabatt',
          badgeGridSale: 'zusätzlich −20 % Geburtstagsrabatt auf den reduzierten Preis',

          badgePdpDefault: '−20 % Geburtstagsrabatt wird zusätzlich abgezogen – auf reguläre und reduzierte Preise',
          badgePdpSaleDefault: 'zusätzlich −20 % Geburtstagsrabatt auf den reduzierten Preis werden im Warenkorb abgezogen',

          badgePdpWouldQualify: 'Mit diesem Produkt: −20 % Geburtstagsrabatt auf deine Bestellung – lege Lieblingsfarben gleich mit dazu',
          badgePdpSaleWouldQualify: 'zusätzlich −20 % Geburtstagsrabatt auf den reduzierten Preis werden im Warenkorb abgezogen',

          badgeActive: '−20 % Geburtstagsrabatt wird zusätzlich abgezogen – auf reguläre und reduzierte Preise',
          badgeSaleActive: 'zusätzlich −20 % Geburtstagsrabatt auf den reduzierten Preis werden im Warenkorb abgezogen',

          badgeNoMin: 'Nur bis Sonntag: −20 % Geburtstagsrabatt',
          badgeSaleNoMin: 'Sale + zusätzlich −20 % Geburtstagsrabatt',

          cartActiveTitle: '−20 % Geburtstagsrabatt aktiv',
          cartActiveText: 'Alles, was du jetzt noch dazulegst, erhält ebenfalls −20 % – auch bereits reduzierte Produkte.',

          cartRecoverTitle: '−20 % freischalten',
          cartRecoverText: 'Dein Warenkorb ist über 50 €. Aktiviere jetzt den Geburtstagsrabatt.',
          cartRecoverButtonText: 'Hier klicken und −20 % Rabatt aktivieren',

          cartMissingPrefix: 'Noch ',
          cartMissingSuffix: ' bis du −20 % auf deine gesamte Bestellung erhältst. Ein weiterer Farbton oder ein Medium bringt dich oft schon dorthin.'
        }
      },

      priceSelectors: [
        '[data-product-price]',
        '[data-price]',
        '.product__price__wrap',
        '.product__price',
        '.product-grid-item__price',
        '.product-item__price',
        '.grid-product__price',
        '.price'
      ].join(','),

      cardRootSelectors: [
        '[data-product-grid-item]',
        '[data-product-card]',
        '.product-grid-item',
        '.product-item',
        '.product-card',
        '.grid-product',
        '.grid-item'
      ].join(','),

      pdpRootSelectors: [
        '.product__info',
        '.product__details',
        '.product__content',
        '.product-single__meta',
        '[data-product-information]',
        '[data-product-info]',
        '[data-product-form]'
      ].join(','),

      excludedAreaSelectors: [
        '.cart',
        '.cart__items',
        '.cart-drawer',
        '.drawer__cart',
        '.ajax-cart',
        '.quick-cart',
        '.cart__drawer',
        '.qsc2-drawer',
        '.aq-discount-badge',
        '.aq-discount-cart-message',
        'form[action="/cart"]',
        'form[action$="/cart"]'
      ].join(','),

      qikify: {
        drawerSelector: '.qsc2-drawer',
        footerSelector: '.qsc2-drawer-footer',
        summarySelector: '.qsc2-drawer-footer__summary',
        subtotalSelector: '.qsc2-drawer-footer__summary-subtotal',

        discountTriggerSelector: '.qsc2-side-feature-btn[data-name="discount"]',
        discountPanelSelector: '.qsc2-sf-content--discount',
        discountInputSelector: '.qsc2-sf-content--discount input[name="discount"]',
        discountApplyButtonSelector: '.qsc2-sf-content--discount .qsc2-sf-discount__action-btn',

        discountCodeSelectors: [
          '.qsc2-drawer-footer__code-label',
          '.qsc2-product-item__discount-title'
        ].join(',')
      }
    };

    if (!AQ_DISCOUNT_CONFIG.enabled) return;

      let currentCart = null;
      let hasTrackedBadgeSeen = false;
      let campaignCountdownTimer = null;
      let renderQueued = false;
      let refreshQueued = false;
      let applyingDiscount = false;
      let qikifyLiveHooksInstalled = false;
      let qikifyDrawerObserverInstalled = false;
      let refreshBatchId = 0;

    function getRootUrl() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }

      return '/';
    }

    function normalizeCode(code) {
      return String(code || '').trim().toUpperCase();
    }

    function getOffer(code) {
      return AQ_DISCOUNT_CONFIG.offers[normalizeCode(code)] || null;
    }

    function normalizeMatchValue(value, caseSensitive) {
      const text = String(value || '').trim();
      return caseSensitive ? text : text.toLowerCase();
    }

    function conditionMatchesSearchParam(searchParams, condition) {
      if (!condition || !condition.name) return false;

      const actualRaw = searchParams.get(condition.name);

      if (condition.match === 'exists') {
        return actualRaw !== null && String(actualRaw).trim() !== '';
      }

      if (actualRaw === null || String(actualRaw).trim() === '') {
        return false;
      }

      const caseSensitive = Boolean(condition.caseSensitive);
      const actual = normalizeMatchValue(actualRaw, caseSensitive);
      const values = Array.isArray(condition.values)
        ? condition.values
        : [condition.value];

      const matchType = condition.match || 'equals';

      return values.some(function (expectedRaw) {
        const expected = normalizeMatchValue(expectedRaw, caseSensitive);

        if (!expected) return false;

        if (matchType === 'contains') {
          return actual.indexOf(expected) !== -1;
        }

        if (matchType === 'startsWith') {
          return actual.indexOf(expected) === 0;
        }

        if (matchType === 'endsWith') {
          return actual.slice(-expected.length) === expected;
        }

        return actual === expected;
      });
    }

    function pathRuleMatchesCurrentPath(rule) {
      if (!rule || !rule.path) return false;

      const currentPath = normalizePath(window.location.pathname);
      const rulePath = normalizePath(rule.path);
      const matchType = rule.match || 'exact';

      if (matchType === 'prefix') {
        return currentPath === rulePath || currentPath.indexOf(rulePath + '/') === 0;
      }

      if (matchType === 'contains') {
        return currentPath.indexOf(rulePath) !== -1;
      }

      return currentPath === rulePath;
    }

    function utmRuleMatches(searchParams, rule) {
      if (!rule || !Array.isArray(rule.conditions) || rule.conditions.length === 0) {
        return false;
      }

      const operator = rule.operator || 'all';

      if (operator === 'any') {
        return rule.conditions.some(function (condition) {
          return conditionMatchesSearchParam(searchParams, condition);
        });
      }

      return rule.conditions.every(function (condition) {
        return conditionMatchesSearchParam(searchParams, condition);
      });
    }

    function getCampaignUrlTriggerContext() {
      const url = new URL(window.location.href);
      const campaignCode = normalizeCode(AQ_CAMPAIGN_CONTROL.code);
      const trigger = AQ_CAMPAIGN_CONTROL.trigger || {};

      /*
        1) Native Shopify discount URL:
        /discount/5jahrefarbe?redirect=...
        This already is the Shopify discount mechanism.
      */
      const discountPathMatch = window.location.pathname.match(/\/discount\/([^/?#]+)/i);

      if (discountPathMatch && discountPathMatch[1] && getOffer(discountPathMatch[1])) {
        return {
          code: normalizeCode(decodeURIComponent(discountPathMatch[1])),
          source: 'shopifyDiscountPath'
        };
      }

      /*
        2) Existing simple discount params:
        ?aq_discount=5JAHREFARBE
        ?discount=5JAHREFARBE
      */
      for (const paramName of AQ_DISCOUNT_CONFIG.urlParamNames) {
        const value = url.searchParams.get(paramName);

        if (value && getOffer(value)) {
          return {
            code: normalizeCode(value),
            source: 'nativeQueryParam'
          };
        }
      }

      /*
        3) Configurable query param triggers.
      */
      if (
        AQ_CAMPAIGN_CONTROL.enabled &&
        trigger.enabled !== false &&
        Array.isArray(trigger.queryParams) &&
        trigger.queryParams.some(function (condition) {
          return conditionMatchesSearchParam(url.searchParams, condition);
        }) &&
        getOffer(campaignCode)
      ) {
        return {
          code: campaignCode,
          source: 'queryParams'
        };
      }

      /*
        4) Configurable path triggers.
        Example: Landingpage, PDP, Collection.
      */
      if (
        AQ_CAMPAIGN_CONTROL.enabled &&
        trigger.enabled !== false &&
        Array.isArray(trigger.paths) &&
        trigger.paths.some(pathRuleMatchesCurrentPath) &&
        getOffer(campaignCode)
      ) {
        return {
          code: campaignCode,
          source: 'paths'
        };
      }

      /*
        5) Configurable UTM triggers.
        Example: utm_medium=paid or utm_medium=PaidSocial.
      */
      if (
        AQ_CAMPAIGN_CONTROL.enabled &&
        trigger.enabled !== false &&
        Array.isArray(trigger.utmRules) &&
        trigger.utmRules.some(function (rule) {
          return utmRuleMatches(url.searchParams, rule);
        }) &&
        getOffer(campaignCode)
      ) {
        return {
          code: campaignCode,
          source: 'utmRules'
        };
      }

      /*
        6) Legacy landing page fallback.
      */
      const normalizedPath = normalizePath(window.location.pathname);
      const fallbackCode = AQ_DISCOUNT_CONFIG.campaignLandingPages[normalizedPath];

      if (fallbackCode && getOffer(fallbackCode)) {
        return {
          code: normalizeCode(fallbackCode),
          source: 'legacyLandingPage'
        };
      }

      return {
        code: '',
        source: ''
      };
    }

    function getCodeFromUrl() {
      return getCampaignUrlTriggerContext().code;
    }

    function setStoredCode(code) {
      if (isCampaignExpired()) {
        clearExpiredCampaignState();
        return;
      }

      const offer = getOffer(code);
      if (!offer) return;

      const expiresAt = Date.now() + AQ_DISCOUNT_CONFIG.persistDays * 24 * 60 * 60 * 1000;

      try {
        localStorage.setItem(AQ_DISCOUNT_CONFIG.storageKey, offer.code);
        localStorage.setItem(AQ_DISCOUNT_CONFIG.storageExpiresAtKey, String(expiresAt));
      } catch (error) {
        console.warn('[AQ Discount] Could not store discount code:', error);
      }
    }

    function getStoredCode() {
      try {
        const code = normalizeCode(localStorage.getItem(AQ_DISCOUNT_CONFIG.storageKey));
        const expiresAt = Number(localStorage.getItem(AQ_DISCOUNT_CONFIG.storageExpiresAtKey));

        if (!code || !expiresAt || Date.now() > expiresAt) {
          localStorage.removeItem(AQ_DISCOUNT_CONFIG.storageKey);
          localStorage.removeItem(AQ_DISCOUNT_CONFIG.storageExpiresAtKey);
          return '';
        }

        if (!getOffer(code)) return '';

        return code;
      } catch (error) {
        return '';
      }
    }

    function getActiveCode() {
      if (isCampaignExpired()) {
        clearExpiredCampaignState();
        return '';
      }

      const codeFromUrl = getCodeFromUrl();

      if (codeFromUrl && getOffer(codeFromUrl)) {
        setStoredCode(codeFromUrl);
        return codeFromUrl;
      }

      const storedCode = getStoredCode();

      if (storedCode && getOffer(storedCode)) {
        return storedCode;
      }

      const syncedCode = syncCampaignCodeFromCartOrDrawer();

      if (syncedCode && getOffer(syncedCode)) {
        return syncedCode;
      }

      return '';
    }

    function getCurrentRelativeUrl() {
      return window.location.pathname + window.location.search + window.location.hash;
    }

    function shouldAutoRedirectThroughDiscountLink(context) {
      const trigger = AQ_CAMPAIGN_CONTROL.trigger || {};
      const redirectConfig = trigger.redirectThroughDiscountLink || {};

      if (!AQ_CAMPAIGN_CONTROL.enabled) return false;
      if (trigger.enabled === false) return false;
      if (!redirectConfig.enabled) return false;
      if (isCampaignExpired()) return false;

      if (!context || !context.code || !context.source) {
        return false;
      }

      const allowedSources = Array.isArray(redirectConfig.sources)
        ? redirectConfig.sources
        : [];

      if (!allowedSources.includes(context.source)) {
        return false;
      }

      const normalizedCode = normalizeCode(context.code);

      if (!normalizedCode || normalizedCode !== normalizeCode(AQ_CAMPAIGN_CONTROL.code)) {
        return false;
      }

      if (!getOffer(normalizedCode)) {
        return false;
      }

      /*
        Do not redirect while already on Shopify's discount route.
      */
      if (/\/discount\//i.test(window.location.pathname)) {
        return false;
      }

      /*
        Avoid redirect loops within the same browser session.
      */
      try {
        const sessionKey = redirectConfig.sessionKey || 'aq_campaign_discount_redirect_done';
        const alreadyRedirected = sessionStorage.getItem(sessionKey);

        if (alreadyRedirected === normalizedCode) {
          return false;
        }
      } catch (error) {}

      return true;
    }

    function maybeRedirectThroughDiscountLink() {
      const trigger = AQ_CAMPAIGN_CONTROL.trigger || {};
      const redirectConfig = trigger.redirectThroughDiscountLink || {};
      const context = getCampaignUrlTriggerContext();

      if (!shouldAutoRedirectThroughDiscountLink(context)) {
        return;
      }

      const normalizedCode = normalizeCode(context.code);

      try {
        const sessionKey = redirectConfig.sessionKey || 'aq_campaign_discount_redirect_done';
        sessionStorage.setItem(sessionKey, normalizedCode);
      } catch (error) {}

      const redirectTarget = getCurrentRelativeUrl();
      const discountUrl =
        getRootUrl() +
        'discount/' +
        encodeURIComponent(String(normalizedCode).toLowerCase()) +
        '?redirect=' +
        encodeURIComponent(redirectTarget);

      window.location.replace(discountUrl);
    }

    function getCampaignCode() {
      return normalizeCode(AQ_CAMPAIGN_CONTROL.code);
    }

    function getCampaignEndTimeMs() {
      const countdown = AQ_CAMPAIGN_CONTROL.countdown || {};

      if (!countdown.enabled || !countdown.endsAtIso) {
        return 0;
      }

      const endTime = Date.parse(countdown.endsAtIso);

      return Number.isFinite(endTime) ? endTime : 0;
    }

    function isCampaignExpired() {
      const endTime = getCampaignEndTimeMs();

      if (!endTime) return false;

      return Date.now() >= endTime;
    }

    function clearExpiredCampaignState() {
      try {
        localStorage.removeItem(AQ_DISCOUNT_CONFIG.storageKey);
        localStorage.removeItem(AQ_DISCOUNT_CONFIG.storageExpiresAtKey);
      } catch (error) {}

      try {
        const redirectConfig =
          AQ_CAMPAIGN_CONTROL.trigger &&
          AQ_CAMPAIGN_CONTROL.trigger.redirectThroughDiscountLink;

        const sessionKey =
          (redirectConfig && redirectConfig.sessionKey) ||
          'aq_campaign_discount_redirect_done';

        sessionStorage.removeItem(sessionKey);
      } catch (error) {}
    }

    function padCountdownNumber(value) {
      return String(value).padStart(2, '0');
    }

    function formatCampaignCountdown(remainingMs) {
      const totalSeconds = Math.max(Math.floor(remainingMs / 1000), 0);

      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (days > 0) {
        return (
          days +
          'T ' +
          padCountdownNumber(hours) +
          ':' +
          padCountdownNumber(minutes) +
          ':' +
          padCountdownNumber(seconds)
        );
      }

      return (
        padCountdownNumber(hours) +
        ':' +
        padCountdownNumber(minutes) +
        ':' +
        padCountdownNumber(seconds)
      );
    }

    function getCampaignCountdownText() {
      const endTime = getCampaignEndTimeMs();

      if (!endTime) return '';

      const remainingMs = endTime - Date.now();

      if (remainingMs <= 0) return '';

      return formatCampaignCountdown(remainingMs);
    }

    function persistCampaignCodeIfValid(code) {
      const normalizedCode = normalizeCode(code);

      if (!normalizedCode || normalizedCode !== getCampaignCode()) {
        return false;
      }

      if (!getOffer(normalizedCode)) {
        return false;
      }

      setStoredCode(normalizedCode);
      return true;
    }

    function syncCampaignCodeFromCartOrDrawer() {
      const campaignCode = getCampaignCode();

      if (!campaignCode || !getOffer(campaignCode)) {
        return '';
      }

      if (currentCart) {
        const discountStrings = collectDiscountStringsFromCart(currentCart);

        if (discountStrings.some((value) => value.includes(campaignCode))) {
          setStoredCode(campaignCode);
          return campaignCode;
        }
      }

      const drawer = document.querySelector(AQ_DISCOUNT_CONFIG.qikify.drawerSelector);

      if (drawer) {
        const visibleDiscountText = Array.from(
          drawer.querySelectorAll(AQ_DISCOUNT_CONFIG.qikify.discountCodeSelectors)
        )
          .map((element) => normalizeCode(element.textContent))
          .join(' ');

        if (visibleDiscountText.includes(campaignCode)) {
          setStoredCode(campaignCode);
          return campaignCode;
        }
      }

      return '';
    }

    function persistCampaignCodeFromQikifyInput() {
      const drawer = document.querySelector(AQ_DISCOUNT_CONFIG.qikify.drawerSelector);

      if (!drawer) return false;

      const input = drawer.querySelector(AQ_DISCOUNT_CONFIG.qikify.discountInputSelector);

      if (!input) return false;

      const inputCode = normalizeCode(input.value);

      if (!persistCampaignCodeIfValid(inputCode)) {
        return false;
      }

      document.dispatchEvent(
        new CustomEvent('aq:campaign-code-detected', {
          detail: {
            aq_discount_code: inputCode,
            aq_discount_source: 'qikify_discount_input'
          }
        })
      );

      return true;
    }

    function normalizePath(path) {
      const value = String(path || '').split('?')[0].split('#')[0];

      if (!value || value === '/') return '/';

      return value.replace(/\/$/, '');
    }

    function getCampaignLandingUrl() {
      const configuredUrl = AQ_CAMPAIGN_CONTROL.returnBar && AQ_CAMPAIGN_CONTROL.returnBar.url;

      if (configuredUrl) {
        const value = String(configuredUrl).trim();

        if (/^https?:\/\//i.test(value)) {
          return value;
        }

        if (value.charAt(0) === '/') {
          return value;
        }

        return getRootUrl() + value.replace(/^\/+/, '');
      }

      const rootUrl = getRootUrl();
      const landingPath = String(AQ_CAMPAIGN_CONTROL.landingPath || '').replace(/^\/+/, '');

      return rootUrl + landingPath;
    }

    function isCurrentCampaignLandingPage() {
      return normalizePath(window.location.pathname) === normalizePath(AQ_CAMPAIGN_CONTROL.landingPath);
    }

    function shouldShowCampaignReturnBar() {
      if (!AQ_CAMPAIGN_CONTROL.enabled) return false;
      if (!AQ_CAMPAIGN_CONTROL.returnBar || !AQ_CAMPAIGN_CONTROL.returnBar.enabled) return false;

      const activeCode = normalizeCode(getActiveCode());

      if (!activeCode || activeCode !== normalizeCode(AQ_CAMPAIGN_CONTROL.code)) {
        return false;
      }

      if (AQ_CAMPAIGN_CONTROL.returnBar.hideOnLandingPage && isCurrentCampaignLandingPage()) {
        return false;
      }

      return true;
    }

    function getHeaderMountTarget() {
      return (
        document.querySelector('[id^="shopify-section-sections--"][id$="__header"]') ||
        document.querySelector('#shopify-section-header') ||
        document.querySelector('.shopify-section-header') ||
        document.querySelector('[data-section-type="header"]') ||
        document.querySelector('header[role="banner"]') ||
        document.querySelector('header')
      );
    }

    function ensureCampaignCountdownTicker() {
      const countdown = AQ_CAMPAIGN_CONTROL.countdown || {};

      if (!countdown.enabled || campaignCountdownTimer) return;

      campaignCountdownTimer = window.setInterval(function () {
        if (isCampaignExpired()) {
          window.clearInterval(campaignCountdownTimer);
          campaignCountdownTimer = null;

          clearExpiredCampaignState();
          clearDiscountBadges();
          renderCampaignReturnBar();
          renderCartDrawerMessage();

          return;
        }

        renderCampaignReturnBar();
      }, 1000);
    }

    function renderCampaignReturnBar() {
      let bar = document.querySelector('.aq-campaign-return-bar');

      if (!shouldShowCampaignReturnBar()) {
        if (bar) bar.remove();
        return;
      }

      const href = getCampaignLandingUrl();
      const text = AQ_CAMPAIGN_CONTROL.returnBar.text || 'Zur Aktion';
      const ariaLabel = AQ_CAMPAIGN_CONTROL.returnBar.ariaLabel || text;
      const countdown = AQ_CAMPAIGN_CONTROL.countdown || {};
      const countdownText = countdown.enabled ? getCampaignCountdownText() : '';

      if (!bar) {
        bar = document.createElement('a');
        bar.className = 'aq-campaign-return-bar';
        bar.setAttribute('data-aq-campaign-code', AQ_CAMPAIGN_CONTROL.code);

        const header = getHeaderMountTarget();

        if (header && header.parentNode) {
          header.insertAdjacentElement('afterend', bar);
        } else if (document.body) {
          document.body.insertAdjacentElement('afterbegin', bar);
        } else {
          return;
        }
      }

      bar.href = href;
      bar.setAttribute('aria-label', ariaLabel);

      if (countdownText) {
        bar.classList.add('aq-campaign-return-bar--has-countdown');

        bar.innerHTML =
          '<span class="aq-campaign-return-bar__label">' +
            escapeHtml(countdown.label || 'Aktion endet in') +
          '</span>' +
          '<span class="aq-campaign-return-bar__timer" aria-label="Verbleibende Zeit">' +
            escapeHtml(countdownText) +
          '</span>' +
          '<span class="aq-campaign-return-bar__cta">' +
            escapeHtml(text) +
          '</span>';

        ensureCampaignCountdownTicker();
      } else {
        bar.classList.remove('aq-campaign-return-bar--has-countdown');
        bar.textContent = text;
      }
    }

    function formatMoneyFromCents(cents) {
      const value = Number(cents || 0) / 100;

      return new Intl.NumberFormat('de-AT', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      }).format(value);
    }

    function escapeHtml(value) {
      const element = document.createElement('div');
      element.textContent = String(value || '');
      return element.innerHTML;
    }

    function waitForQikifyElement(root, selector, timeoutMs) {
      return new Promise((resolve) => {
        const startTime = Date.now();

        function check() {
          const element = root && root.querySelector ? root.querySelector(selector) : null;

          if (element) {
            resolve(element);
            return;
          }

          if (Date.now() - startTime >= timeoutMs) {
            resolve(null);
            return;
          }

          window.setTimeout(check, 50);
        }

        check();
      });
    }

    async function applyDiscountViaQikify(offer, triggerButton) {
      if (!offer || !offer.code) return false;

      const drawer = document.querySelector(AQ_DISCOUNT_CONFIG.qikify.drawerSelector);
      if (!drawer) return false;

      const discountTrigger = drawer.querySelector(AQ_DISCOUNT_CONFIG.qikify.discountTriggerSelector);
      if (!discountTrigger) return false;

      if (triggerButton) {
        triggerButton.disabled = true;
        triggerButton.classList.add('is-loading');
        triggerButton.textContent = 'Rabatt wird aktiviert …';
      }

      try {
        setStoredCode(offer.code);

        discountTrigger.click();

        const input = await waitForQikifyElement(
          drawer,
          AQ_DISCOUNT_CONFIG.qikify.discountInputSelector,
          1800
        );

        const applyButton = await waitForQikifyElement(
          drawer,
          AQ_DISCOUNT_CONFIG.qikify.discountApplyButtonSelector,
          1800
        );

        if (!input || !applyButton) {
          if (triggerButton) {
            triggerButton.disabled = false;
            triggerButton.classList.remove('is-loading');
            triggerButton.textContent = offer.cartRecoverButtonText || 'Rabatt jetzt aktivieren';
          }

          return false;
        }

        input.focus();
        input.value = offer.code;

        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));

        window.setTimeout(function () {
          applyButton.click();

          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'aq_discount_recover_clicked',
              aq_discount_code: offer.code,
              aq_discount_type: offer.type,
              aq_discount_value: offer.value,
              aq_discount_min_subtotal_cents: offer.minSubtotalCents || 0,
              aq_discount_apply_method: 'qikify_drawer'
            });
          }

          window.setTimeout(async function () {
            await fetchCart();
            renderAll();
          }, 900);

          window.setTimeout(async function () {
            await fetchCart();
            renderAll();
          }, 1800);
        }, 120);

        return true;
      } catch (error) {
        console.warn('[AQ Discount] Could not apply discount via Qikify:', error);

        if (triggerButton) {
          triggerButton.disabled = false;
          triggerButton.classList.remove('is-loading');
          triggerButton.textContent = offer.cartRecoverButtonText || 'Rabatt jetzt aktivieren';
        }

        return false;
      }
    }

    function getCartDrawerMessageModifierClass(offer) {
      const state = getOfferState(offer);
      const hasMinimum = Number(offer.minSubtotalCents || 0) > 0;

      if (!hasMinimum || state.isApplied) {
        return 'aq-discount-cart-message--active';
      }

      if (state.qualifiesBySubtotal && !state.isApplied) {
        return 'aq-discount-cart-message--recover';
      }

      return 'aq-discount-cart-message--missing';
    }

    function bindCartDrawerMessageActions(message, offer) {
      if (!message || !offer) return;

      const qikifyButton = message.querySelector('[data-aq-qikify-discount-apply]');
      if (!qikifyButton) return;

      qikifyButton.addEventListener('click', async function () {
        const success = await applyDiscountViaQikify(offer, qikifyButton);

        if (!success) {
          const drawer = document.querySelector(AQ_DISCOUNT_CONFIG.qikify.drawerSelector);
          const discountTrigger = drawer && drawer.querySelector(AQ_DISCOUNT_CONFIG.qikify.discountTriggerSelector);

          if (discountTrigger) {
            discountTrigger.click();
          }
        }
      });
    }

    function shouldReactToCartUrl(url) {
      return Boolean(url && (
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1
      ));
    }

    async function fetchCart() {
      try {
        const response = await fetch(getRootUrl() + 'cart.js', {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) return null;

        currentCart = await response.json();
        return currentCart;
      } catch (error) {
        console.warn('[AQ Discount] Could not fetch cart:', error);
        return null;
      }
    }

    function getQualifyingCartSubtotalCents(cart) {
      if (!cart) return 0;

      if (Array.isArray(cart.items) && cart.items.length > 0) {
        const sum = cart.items.reduce((total, item) => {
          const originalLinePrice = Number(item.original_line_price);
          const finalLinePrice = Number(item.final_line_price);
          const linePrice = Number(item.line_price);
          const itemPrice = Number(item.price);
          const quantity = Number(item.quantity || 0);

          if (Number.isFinite(originalLinePrice) && originalLinePrice > 0) {
            return total + originalLinePrice;
          }

          if (Number.isFinite(itemPrice) && itemPrice > 0 && quantity > 0) {
            return total + itemPrice * quantity;
          }

          if (Number.isFinite(linePrice) && linePrice > 0) {
            return total + linePrice;
          }

          if (Number.isFinite(finalLinePrice) && finalLinePrice > 0) {
            return total + finalLinePrice;
          }

          return total;
        }, 0);

        if (sum > 0) return sum;
      }

      const originalTotalPrice = Number(cart.original_total_price);
      if (Number.isFinite(originalTotalPrice) && originalTotalPrice > 0) {
        return originalTotalPrice;
      }

      const itemsSubtotalPrice = Number(cart.items_subtotal_price);
      if (Number.isFinite(itemsSubtotalPrice) && itemsSubtotalPrice > 0) {
        return itemsSubtotalPrice;
      }

      const totalPrice = Number(cart.total_price || 0);
      const totalDiscount = Number(cart.total_discount || 0);
      if (totalPrice + totalDiscount > 0) {
        return totalPrice + totalDiscount;
      }

      return 0;
    }

    function collectDiscountStringsFromCart(cart) {
      const values = [];

      if (!cart) return values;

      [
        cart.cart_level_discount_applications,
        cart.discount_applications,
        cart.discount_codes
      ].forEach((list) => {
        if (!Array.isArray(list)) return;

        list.forEach((discount) => {
          if (!discount) return;
          values.push(discount.code, discount.title, discount.discount_application && discount.discount_application.title);
        });
      });

      if (Array.isArray(cart.items)) {
        cart.items.forEach((item) => {
          if (!item) return;

          [
            item.discount_allocations,
            item.line_level_discount_allocations
          ].forEach((list) => {
            if (!Array.isArray(list)) return;

            list.forEach((allocation) => {
              if (!allocation) return;
              values.push(
                allocation.code,
                allocation.title,
                allocation.discount_application && allocation.discount_application.title
              );
            });
          });
        });
      }

      return values.filter(Boolean).map((value) => normalizeCode(value));
    }

    function isOfferVisibleInQikifyDrawer(offer) {
      const drawer = document.querySelector(AQ_DISCOUNT_CONFIG.qikify.drawerSelector);
      if (!drawer || !offer) return false;

      const code = normalizeCode(offer.code);

      return Array.from(drawer.querySelectorAll(AQ_DISCOUNT_CONFIG.qikify.discountCodeSelectors))
        .some((element) => normalizeCode(element.textContent).includes(code));
    }

    function isOfferAppliedInCart(offer) {
      if (!offer || !currentCart) return false;

      const code = normalizeCode(offer.code);
      const discountStrings = collectDiscountStringsFromCart(currentCart);

      if (discountStrings.some((value) => value.includes(code))) {
        return true;
      }

      if (isOfferVisibleInQikifyDrawer(offer)) {
        return true;
      }

      const totalDiscount = Number(currentCart.total_discount || 0);
      const activeCode = normalizeCode(getActiveCode());

      return activeCode === code && totalDiscount > 0;
    }

    function getQualifyingSubtotalFromQikifyDrawer() {
      const drawer = document.querySelector('.qsc2-drawer');
      if (!drawer) return 0;

      const subtotalWrapper = drawer.querySelector('.qsc2-drawer-footer__summary-subtotal-price');
      if (!subtotalWrapper) return 0;

      const originalPrice = subtotalWrapper.querySelector('.qsc2-original-price');

      if (originalPrice) {
        const originalAmounts = extractEuroAmountsFromText(originalPrice.textContent);
        if (originalAmounts.length > 0) {
          return Math.max.apply(null, originalAmounts);
        }
      }

      const amounts = extractEuroAmountsFromText(subtotalWrapper.textContent);

      if (amounts.length > 0) {
        return Math.max.apply(null, amounts);
      }

      return 0;
    }

    function getOfferState(offer) {
      const cartSubtotalCents = getQualifyingCartSubtotalCents(currentCart);
      const drawerSubtotalCents = getQualifyingSubtotalFromQikifyDrawer();

      /*
        If the Qikify drawer is present and has a visible subtotal,
        prefer that value because it updates immediately after quantity changes.
      */
      const subtotalCents = drawerSubtotalCents > 0
        ? drawerSubtotalCents
        : cartSubtotalCents;

      const minSubtotalCents = Number(offer.minSubtotalCents || 0);
      const isApplied = isOfferAppliedInCart(offer);
      const qualifiesBySubtotal = minSubtotalCents > 0 && subtotalCents >= minSubtotalCents;

      const isActive = minSubtotalCents > 0
        ? qualifiesBySubtotal
        : isApplied;

      const missingCents = Math.max(minSubtotalCents - subtotalCents, 0);

      return {
        subtotalCents,
        minSubtotalCents,
        isApplied,
        qualifiesBySubtotal,
        isActive,
        missingCents
      };
    }

    async function applyDiscountToCart(code) {
      const offer = getOffer(code);
      if (!offer || !offer.applyToCart || applyingDiscount) return;

      applyingDiscount = true;

      try {
        const response = await fetch(getRootUrl() + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            discount: offer.code
          })
        });

        if (!response.ok) {
          console.warn('[AQ Discount] Could not apply discount code:', offer.code);
          return;
        }

        currentCart = await response.json();

        document.dispatchEvent(
          new CustomEvent('aq:discount-applied', {
            detail: {
              aq_discount_code: offer.code,
              aq_discount_value: offer.value,
              aq_discount_type: offer.type
            }
          })
        );
      } catch (error) {
        console.warn('[AQ Discount] Error applying discount:', error);
      } finally {
        applyingDiscount = false;
      }
    }

    async function ensureDiscountAppliedIfUseful(offer) {
      if (!offer || !offer.applyToCart) return;
      if (!currentCart || Number(currentCart.item_count || 0) <= 0) return;

      const state = getOfferState(offer);

      /*
        Avoid unnecessary /cart/update.js calls.
        This reduces side effects with Qikify / Sticky Cart scripts.
      */
      if (!state.qualifiesBySubtotal) return;

      if (!state.isApplied) {
        await applyDiscountToCart(offer.code);
        await fetchCart();
      }
    }

    function isElementInExcludedArea(element) {
      return Boolean(element.closest(AQ_DISCOUNT_CONFIG.excludedAreaSelectors));
    }

    function getProductHandleFromElement(element) {
      const productRoot = element.closest(
        AQ_DISCOUNT_CONFIG.cardRootSelectors + ', ' + AQ_DISCOUNT_CONFIG.pdpRootSelectors
      );

      const link =
        (productRoot && productRoot.querySelector('a[href*="/products/"]')) ||
        element.closest('a[href*="/products/"]') ||
        document.querySelector('link[rel="canonical"][href*="/products/"]');

      if (!link) {
        const pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
        return pathMatch ? pathMatch[1] : '';
      }

      const href = link.getAttribute('href') || '';
      const match = href.match(/\/products\/([^/?#]+)/);

      return match ? match[1] : '';
    }

    function isEligibleForOffer(element, offer) {
      if (!offer) return false;

      if (offer.appliesTo === 'all') return true;

      if (offer.appliesTo === 'products') {
        const handle = getProductHandleFromElement(element);
        return offer.productHandles.includes(handle);
      }

      return false;
    }

    function isProductPage() {
      return /\/products\//.test(window.location.pathname);
    }

    function textContainsPolicyCopy(element) {
      const text = String(element.textContent || '').toLowerCase();

      return (
        text.includes('steuern') ||
        text.includes('steuer') ||
        text.includes('versand') ||
        text.includes('kasse') ||
        text.includes('tax') ||
        text.includes('shipping')
      );
    }

    function textContainsPrice(element) {
      const text = String(element.textContent || '').trim();

      return (
        text.includes('€') ||
        text.includes('EUR') ||
        /\d+,\d{2}/.test(text) ||
        /\d+\.\d{2}/.test(text)
      );
    }

    function isInsidePolicyArea(element) {
      return Boolean(
        element.closest(
          '.product__policies, .product__tax, .product__shipping, [data-product-policies], [data-shopify="payment-terms"]'
        )
      );
    }

    function extractEuroAmountsFromText(text) {
      const matches = String(text || '').match(/€\s?\d{1,4}(?:[.,]\d{2})?|\d{1,4}(?:[.,]\d{2})\s?€/g);
      if (!matches) return [];

      return matches
        .map((match) => {
          const normalized = match
            .replace('€', '')
            .replace(/\s/g, '')
            .replace('.', '')
            .replace(',', '.');

          const number = Number(normalized);
          if (!Number.isFinite(number) || number <= 0) return 0;

          return Math.round(number * 100);
        })
        .filter((amount) => amount > 0);
    }

    function getDisplayedPriceCents(root) {
      if (!root) return 0;

      const focusedSelectors = [
        '[data-product-price]',
        '[data-price]',
        '.product__price',
        '.price',
        '.new-price'
      ];

      for (const selector of focusedSelectors) {
        const candidates = Array.from(root.querySelectorAll(selector));

        for (const candidate of candidates) {
          if (!candidate || isInsidePolicyArea(candidate) || textContainsPolicyCopy(candidate)) continue;

          const amounts = extractEuroAmountsFromText(candidate.textContent);

          if (amounts.length > 0) {
            return Math.min.apply(null, amounts);
          }
        }
      }

      const fallbackAmounts = extractEuroAmountsFromText(root.textContent);
      if (fallbackAmounts.length > 0) {
        return Math.min.apply(null, fallbackAmounts);
      }

      return 0;
    }

    function getBadgeContext(priceElement) {
      if (isProductPage()) {
        const pdpRoot = priceElement.closest(AQ_DISCOUNT_CONFIG.pdpRootSelectors);

        if (pdpRoot) {
          return {
            type: 'pdp',
            root: pdpRoot,
            target: getPreferredPdpPriceTarget(pdpRoot, priceElement)
          };
        }
      }

      const cardRoot = priceElement.closest(AQ_DISCOUNT_CONFIG.cardRootSelectors);

      if (cardRoot) {
        return {
          type: 'grid',
          root: cardRoot,
          target: getPreferredPriceTarget(cardRoot, priceElement)
        };
      }

      const standaloneRoot =
        priceElement.closest('.product__price__wrap, .product__price, .price') || priceElement;

      return {
        type: 'standalone',
        root: standaloneRoot,
        target: standaloneRoot
      };
    }

    function getPreferredPdpPriceTarget(root, fallbackElement) {
      const selectors = [
        '.product__price__wrap > .product__price',
        '.product__price:not(.product__price--off)',
        '[data-price-wrapper]',
        '[data-product-price]',
        '[data-price]',
        '.price'
      ];

      for (const selector of selectors) {
        const candidates = Array.from(root.querySelectorAll(selector));

        for (const candidate of candidates) {
          if (!candidate) continue;
          if (candidate.closest('.aq-discount-badge')) continue;
          if (isElementInExcludedArea(candidate)) continue;
          if (isInsidePolicyArea(candidate)) continue;
          if (textContainsPolicyCopy(candidate)) continue;
          if (!textContainsPrice(candidate)) continue;

          const priceRow =
            candidate.closest('.product__price') ||
            candidate.closest('[data-price-wrapper]') ||
            candidate.closest('.price') ||
            candidate;

          if (!priceRow) continue;
          if (isInsidePolicyArea(priceRow)) continue;
          if (textContainsPolicyCopy(priceRow)) continue;

          return priceRow;
        }
      }

      return getPreferredPriceTarget(root, fallbackElement);
    }

    function getPreferredPriceTarget(root, fallbackElement) {
      const preferredSelectors = [
        '.product__price__wrap > .product__price',
        '.product__price:not(.product__price--off)',
        '.product-grid-item__price',
        '.product-item__price',
        '.grid-product__price',
        '[data-product-price]',
        '[data-price-wrapper]',
        '[data-price]',
        '.price'
      ];

      for (const selector of preferredSelectors) {
        if (root.matches && root.matches(selector) && !textContainsPolicyCopy(root)) {
          return root;
        }

        const candidates = Array.from(root.querySelectorAll(selector));

        for (const target of candidates) {
          if (!target) continue;
          if (target.closest('.aq-discount-badge')) continue;
          if (isInsidePolicyArea(target)) continue;
          if (textContainsPolicyCopy(target)) continue;

          return target;
        }
      }

      return fallbackElement;
    }

    function isSaleBadgeContext(context) {
      const root = context && context.root;
      if (!root) return false;

      const saleSelectors = [
        '.old-price',
        '.price.sale',
        '.price--on-sale',
        's.product__price--strike',
        '[data-compare-price]',
        '.product__sale .product__price--off',
        '.product__sale [data-price-off-badge]',
        '.dmixer-price-wrapper'
      ];

      return saleSelectors.some((selector) => {
        return Boolean(
          (root.matches && root.matches(selector)) ||
          (root.querySelector && root.querySelector(selector))
        );
      });
    }

    function getBadgeText(offer, context) {
      if (!offer) return '';

      const isSale = isSaleBadgeContext(context);

      if (!offer.minSubtotalCents || offer.minSubtotalCents <= 0) {
        return isSale
          ? (offer.badgeSaleNoMin || offer.badgeNoMin)
          : offer.badgeNoMin;
      }

      const state = getOfferState(offer);

      if (state.isActive) {
        return isSale
          ? (offer.badgeSaleActive || offer.badgeActive)
          : offer.badgeActive;
      }

      if (context && context.type === 'pdp') {
        const productPriceCents = getDisplayedPriceCents(context.root);
        const subtotalIfAdded = state.subtotalCents + productPriceCents;

        if (productPriceCents > 0 && subtotalIfAdded >= offer.minSubtotalCents) {
          return isSale
            ? (offer.badgePdpSaleWouldQualify || offer.badgePdpWouldQualify)
            : offer.badgePdpWouldQualify;
        }

        return isSale
          ? (offer.badgePdpSaleDefault || offer.badgePdpDefault)
          : offer.badgePdpDefault;
      }

      if (context && context.type === 'grid') {
        return isSale
          ? (offer.badgeGridSale || offer.badgeGrid)
          : offer.badgeGrid;
      }

      return isSale
        ? (offer.badgePdpSaleDefault || offer.badgePdpDefault || offer.badgeGrid)
        : (offer.badgePdpDefault || offer.badgeGrid);
    }

    function renderDiscountBadges() {
      const activeCode = getActiveCode();
      const offer = getOffer(activeCode);

      if (!offer) return;

      const priceElements = Array.from(document.querySelectorAll(AQ_DISCOUNT_CONFIG.priceSelectors));
      const handledRoots = new Set();

      priceElements.forEach((priceElement) => {
        if (!priceElement) return;
        if (isElementInExcludedArea(priceElement)) return;
        if (!isEligibleForOffer(priceElement, offer)) return;

        const context = getBadgeContext(priceElement);
        if (!context || !context.root || !context.target) return;

        const root = context.root;
        const target = context.target;

        if (handledRoots.has(root)) return;
        handledRoots.add(root);

        /*
          Broadcast replaces the price DOM on variant change.
          The root may still be marked as initialized while the actual badge
          has been removed together with the old price node.
        */
        const existingBadge =
          root.querySelector('.aq-discount-badge') ||
          (target.nextElementSibling && target.nextElementSibling.classList.contains('aq-discount-badge')
            ? target.nextElementSibling
            : null);

        if (existingBadge) return;

        root.dataset.aqDiscountBadgeRootInitialized = 'false';

        const badgeText = getBadgeText(offer, context);
        if (!badgeText) return;

        const badge = document.createElement('span');
        badge.className = 'aq-discount-badge';
        badge.setAttribute('aria-label', badgeText);
        badge.textContent = badgeText;

        target.insertAdjacentElement('afterend', badge);
        root.dataset.aqDiscountBadgeRootInitialized = 'true';

        if (window.dataLayer && !hasTrackedBadgeSeen) {
          window.dataLayer.push({
            event: 'aq_discount_badge_seen',
            aq_discount_code: offer.code,
            aq_discount_type: offer.type,
            aq_discount_value: offer.value,
            aq_discount_min_subtotal_cents: offer.minSubtotalCents || 0
          });

          hasTrackedBadgeSeen = true;
        }
      });
    }

    function getCartDrawerMessageHtml(offer) {
      const state = getOfferState(offer);
      const drawer = document.querySelector(AQ_DISCOUNT_CONFIG.qikify.drawerSelector);
      const drawerHasItems = drawer && drawer.querySelector('.qsc2-product-item-wrapper');
      const hasMinimum = Number(offer.minSubtotalCents || 0) > 0;

      if ((!currentCart || Number(currentCart.item_count || 0) <= 0) && !drawerHasItems) {
        return '';
      }

      if (!hasMinimum || state.isApplied) {
        return (
          '<div class="aq-discount-cart-message__title">' + escapeHtml(offer.cartActiveTitle || 'Rabatt aktiv') + '</div>' +
          '<div class="aq-discount-cart-message__text">' +
            escapeHtml(offer.cartActiveText || ('Du sparst zusätzlich −' + offer.value + ' % mit ' + offer.code + '.')) +
          '</div>'
        );
      }

      if (state.qualifiesBySubtotal && !state.isApplied) {
        return (
          '<div class="aq-discount-cart-message__title">' + escapeHtml(offer.cartRecoverTitle || 'Rabatt sichern') + '</div>' +
          '<div class="aq-discount-cart-message__text">' +
            escapeHtml(offer.cartRecoverText || ('Aktiviere den Code ' + offer.code + ', um deinen Rabatt zu sichern.')) +
          '</div>' +
          '<button class="aq-discount-cart-message__button" type="button" data-aq-qikify-discount-apply="' + escapeHtml(offer.code) + '">' +
            escapeHtml(offer.cartRecoverButtonText || 'Rabatt jetzt aktivieren') +
          '</button>'
        );
      }

      return (
        '<div class="aq-discount-cart-message__title">Geburtstagsrabatt sichern</div>' +
        '<div class="aq-discount-cart-message__text">' +
          escapeHtml(offer.cartMissingPrefix || 'Noch ') +
          '<strong>' + formatMoneyFromCents(state.missingCents) + '</strong>' +
          escapeHtml(offer.cartMissingSuffix || (' bis zum Rabatt −' + offer.value + ' %')) +
        '</div>'
      );
    }

    function renderCartDrawerMessage() {
      const activeCode = getActiveCode();
      const offer = getOffer(activeCode);
      const drawer = document.querySelector(AQ_DISCOUNT_CONFIG.qikify.drawerSelector);

      if (!drawer) return;

      let message = drawer.querySelector('.aq-discount-cart-message');

      if (!offer) {
        if (message) message.remove();
        return;
      }
      const html = getCartDrawerMessageHtml(offer);

      if (!html) {
        if (message) message.remove();
        return;
      }

      if (!message) {
        message = document.createElement('div');
        message.className = 'aq-discount-cart-message';
        message.setAttribute('role', 'status');
        message.setAttribute('aria-live', 'polite');

        const sideFeatures = drawer.querySelector('.qsc2-side-features');
        const summary =
          drawer.querySelector(AQ_DISCOUNT_CONFIG.qikify.summarySelector) ||
          drawer.querySelector(AQ_DISCOUNT_CONFIG.qikify.footerSelector);

        if (sideFeatures) {
          sideFeatures.insertAdjacentElement('beforebegin', message);
        } else if (summary) {
          summary.insertAdjacentElement('beforebegin', message);
        } else {
          return;
        }
      }

      message.className = 'aq-discount-cart-message ' + getCartDrawerMessageModifierClass(offer);
      message.innerHTML = html;
      bindCartDrawerMessageActions(message, offer);
    }

    function renderCartTaxExemptionBlock() {
      const drawer = document.querySelector(AQ_DISCOUNT_CONFIG.qikify.drawerSelector);

      if (!drawer) return;

      const sideFeatures = drawer.querySelector('.qsc2-side-features');
      const summary =
        drawer.querySelector(AQ_DISCOUNT_CONFIG.qikify.summarySelector) ||
        drawer.querySelector(AQ_DISCOUNT_CONFIG.qikify.footerSelector);

      if (!sideFeatures && !summary) return;

      let taxWrapper = drawer.querySelector('.aq-cart-tax-wrapper');

      if (!taxWrapper) {
        taxWrapper = document.createElement('div');
        taxWrapper.className = 'aq-cart-tax-wrapper';
        taxWrapper.innerHTML = `
          <button class="aq-cart-tax-toggle" type="button" aria-expanded="false">
            <span class="aq-cart-tax-toggle__label">USt-ID (optional)</span>
            <span class="aq-cart-tax-toggle__icon" aria-hidden="true">▾</span>
          </button>
          <div class="aq-cart-tax-content" hidden>
            <div id="ooTaxExemption"></div>
          </div>
        `;

        const taxMount = taxWrapper.querySelector('#ooTaxExemption');

        if (taxMount && typeof taxMount.closeCartDrawer !== 'function') {
          taxMount.closeCartDrawer = function () {
            const closeButton = document.querySelector('.qsc2-drawer-header__close-button');
            if (closeButton) closeButton.click();
          };
        }

        const toggle = taxWrapper.querySelector('.aq-cart-tax-toggle');
        const content = taxWrapper.querySelector('.aq-cart-tax-content');
        const icon = taxWrapper.querySelector('.aq-cart-tax-toggle__icon');

        toggle.addEventListener('click', function () {
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';

          toggle.setAttribute('aria-expanded', String(!isOpen));
          content.hidden = isOpen;

          if (icon) {
            icon.textContent = isOpen ? '▾' : '▴';
          }
        });
      }

      /*
        Position:
        - Prefer directly above Qikify side-feature buttons.
        - If the discount message exists, keep tax block below the discount message.
        - If no discount message exists, tax block sits directly above Bestellhinweis / Versand / Rabattcode.
      */
      const message = drawer.querySelector('.aq-discount-cart-message');

      if (message && message.nextElementSibling !== taxWrapper) {
        message.insertAdjacentElement('afterend', taxWrapper);
        return;
      }

      if (!message && sideFeatures && sideFeatures.previousElementSibling !== taxWrapper) {
        sideFeatures.insertAdjacentElement('beforebegin', taxWrapper);
        return;
      }

      if (!message && !sideFeatures && summary && summary.previousElementSibling !== taxWrapper) {
        summary.insertAdjacentElement('beforebegin', taxWrapper);
      }
    }

    function clearDiscountBadges() {
      document.querySelectorAll('.aq-discount-badge').forEach((badge) => {
        badge.remove();
      });

      document.querySelectorAll('[data-aq-discount-badge-root-initialized="true"]').forEach((root) => {
        root.dataset.aqDiscountBadgeRootInitialized = 'false';
      });
    }

    function renderAll() {
      renderCampaignReturnBar();
      renderDiscountBadges();
      renderCartDrawerMessage();
      renderCartTaxExemptionBlock();
    }

    function clearAndRenderAll() {
      clearDiscountBadges();
      renderAll();
    }

    function queueRender() {
      if (renderQueued) return;

      renderQueued = true;

      window.requestAnimationFrame(() => {
        renderAll();
        renderQueued = false;
      });
    }

    async function refreshAndRerender(options) {
      const settings = options || {};
      const activeCode = getActiveCode();
      const offer = getOffer(activeCode);

      await fetchCart();

      if (settings.applyDiscount && offer) {
        await ensureDiscountAppliedIfUseful(offer);
      }

      clearAndRenderAll();
    }

    function queueRefresh(options) {
      const settings = options || {};
      const batchId = ++refreshBatchId;

      /*
        Qikify updates its drawer asynchronously.
        One refresh is often too early, so we intentionally check several times.
      */
      [120, 450, 900, 1600].forEach((delay) => {
        window.setTimeout(async () => {
          /*
            Keep the latest batch dominant, but still allow the last slow refresh
            because Qikify sometimes finishes late.
          */
          if (batchId !== refreshBatchId && delay < 900) return;

          await refreshAndRerender(settings);
        }, delay);
      });
    }

    function installCartRequestHooks() {
      if (window.fetch && !window.__aqDiscountCartFetchHooked) {
        window.__aqDiscountCartFetchHooked = true;

        const originalFetch = window.fetch;

        window.fetch = function () {
          const args = arguments;
          const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);

          return originalFetch.apply(this, args).then((response) => {
            if (shouldReactToCartUrl(url)) {
              queueRefresh({ applyDiscount: true });
            }

            return response;
          });
        };
      }

      if (window.XMLHttpRequest && !window.__aqDiscountCartXhrHooked) {
        window.__aqDiscountCartXhrHooked = true;

        const originalOpen = XMLHttpRequest.prototype.open;
        const originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url) {
          this.__aqDiscountIsCartRequest = shouldReactToCartUrl(url);
          return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function () {
          if (this.__aqDiscountIsCartRequest) {
            this.addEventListener('load', function () {
              queueRefresh({ applyDiscount: true });
            });
          }

          return originalSend.apply(this, arguments);
        };
      }
    }

    function isQikifyDrawerElement(element) {
      return Boolean(element && element.closest && element.closest('.qsc2-drawer'));
    }

    function isQikifyCartInteractionTarget(target) {
      if (!target || !target.closest) return false;

      return Boolean(
        target.closest(
          [
            '.qsc2-product-item__quantity-btn',
            '.qsc2-product-item__quantity-input',
            '.qsc2-product-item__remove-btn',
            '.qsc2-quantity-btn--minus',
            '.qsc2-quantity-btn--plus',
            '.qsc2-sf-discount__action-btn',
            '.qsc2-side-feature-btn[data-name="discount"]'
          ].join(',')
        )
      );
    }

    function installQikifyLiveInteractionHooks() {
      if (qikifyLiveHooksInstalled) return;

      qikifyLiveHooksInstalled = true;

      document.addEventListener(
        'click',
        function (event) {
          if (!isQikifyDrawerElement(event.target)) return;
          if (!isQikifyCartInteractionTarget(event.target)) return;

          if (
            event.target.closest &&
            event.target.closest(AQ_DISCOUNT_CONFIG.qikify.discountApplyButtonSelector)
          ) {
            persistCampaignCodeFromQikifyInput();

            window.setTimeout(clearAndRenderAll, 250);
            window.setTimeout(clearAndRenderAll, 900);
            window.setTimeout(clearAndRenderAll, 1600);
          }

          queueRefresh({ applyDiscount: true });
        },
        true
      );

      document.addEventListener(
        'change',
        function (event) {
          if (!isQikifyDrawerElement(event.target)) return;
          if (!isQikifyCartInteractionTarget(event.target)) return;

          queueRefresh({ applyDiscount: true });
        },
        true
      );

      document.addEventListener(
        'input',
        function (event) {
          if (!isQikifyDrawerElement(event.target)) return;
          if (!isQikifyCartInteractionTarget(event.target)) return;

          queueRefresh({ applyDiscount: true });
        },
        true
      );

      document.addEventListener(
        'keyup',
        function (event) {
          if (!isQikifyDrawerElement(event.target)) return;
          if (!isQikifyCartInteractionTarget(event.target)) return;

          queueRefresh({ applyDiscount: true });
        },
        true
      );
    }

    function shouldReactToQikifyMutation(mutation) {
      const target = mutation.target;

      if (!target || !target.closest) return false;

      if (target.closest('.aq-discount-cart-message')) {
        return false;
      }

      if (!target.closest('.qsc2-drawer')) {
        return false;
      }

      return Boolean(
        target.closest(
          [
            '.qsc2-drawer-rows',
            '.qsc2-product-item-wrapper',
            '.qsc2-product-item__quantity',
            '.qsc2-product-item__footer',
            '.qsc2-product-item__line-price-wrapper',
            '.qsc2-product-item__discount-wrapper',
            '.qsc2-drawer-footer__summary',
            '.qsc2-drawer-footer__summary-subtotal',
            '.qsc2-drawer-footer__summary-discount'
          ].join(',')
        )
      );
    }

    function installQikifyDrawerObserver() {
      if (qikifyDrawerObserverInstalled) return;

      const drawer = document.querySelector('.qsc2-drawer');

      if (!drawer) {
        window.setTimeout(installQikifyDrawerObserver, 300);
        return;
      }

      qikifyDrawerObserverInstalled = true;

      const qikifyObserver = new MutationObserver(function (mutations) {
        const shouldRefresh = mutations.some(shouldReactToQikifyMutation);

        if (shouldRefresh) {
          queueRefresh({ applyDiscount: true });
        }
      });

      qikifyObserver.observe(drawer, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'value']
      });
    }

    async function initDiscountBadges() {
      const activeCode = getActiveCode();

      maybeRedirectThroughDiscountLink();

      const offer = getOffer(activeCode);

      /*
        Do not return early here.
        Qikify / Shopify may apply or expose the discount after initial page load.
        The renderer itself decides whether a message should be shown.
      */

      /*
        Stability mode for Qikify Slide Cart:
        - no global fetch/XMLHttpRequest hooks
        - no broad Qikify MutationObserver
        - no automatic /cart/update.js discount application

        Der Rabattcode sollte über Shopifys nativen Discount-Link gesetzt werden:
        /discount/5JAHREFARBE?redirect=/pages/aquarylic-feiert-geburtstag
      */

      clearDiscountBadges();

      await fetchCart();
      renderAll();

      installQikifyLiveInteractionHooks();
      // installQikifyDrawerObserver();
      //
      // Disabled intentionally:
      // The broad Qikify MutationObserver can react repeatedly while Qikify is still
      // rendering the cart drawer. On mobile this can create delayed cart updates and
      // interfere with the drawer opening flow.

      window.setTimeout(renderAll, 500);
      window.setTimeout(renderAll, 1200);
      window.setTimeout(renderAll, 2200);

      const passiveRefresh = window.theme && typeof window.theme.debounce === 'function'
        ? window.theme.debounce(async function () {
            await fetchCart();
            renderAll();
          }, 350)
        : async function () {
            await fetchCart();
            renderAll();
          };

      const passiveCartEvents = [
        'cart:updated',
        'cart:refresh',
        'ajaxProduct:added',
        'product:added',
        'aq:cart-updated',
        'qikify:cart:updated',
        'qikify:cart:open'
      ];

      passiveCartEvents.forEach(function (eventName) {
        document.addEventListener(eventName, function () {
          window.setTimeout(passiveRefresh, 700);
          window.setTimeout(passiveRefresh, 1500);
        });
      });

      document.addEventListener('variant:change', function () {
        window.requestAnimationFrame(clearAndRenderAll);
      });

      document.addEventListener('theme:variant:change', function () {
        window.requestAnimationFrame(clearAndRenderAll);
      });

      document.addEventListener('product:variant-change', function () {
        window.requestAnimationFrame(clearAndRenderAll);
      });

      document.addEventListener('change', function (event) {
        if (!event.target || !event.target.closest('[data-product-form], .product__form, form[action*="/cart/add"]')) return;

        window.setTimeout(clearAndRenderAll, 80);
      }, true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDiscountBadges);
    } else {
      initDiscountBadges();
    }
  })();
})();
